export const getProcessStatementActiveCommentModules = (state) =>
    state.processStatement.visibleCommentModules;
